/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'

/**
 * Import
 * - Actions
 */
import {
    // fetchLocations,
    // addLocations,
    fetchCountries,
    // addLocationsSecurity,
    // deleteLocation
    findLatLong,
} from '../../../../../actions'

/**
 * Import
 * - Page component
 */
import Step02 from '../../../../../components/pages/Quote/Step02/Step02'

const mapStateToProps = (state: RootState, props: any) => {

    return {
        quote: 'The QUOTE! Step02',
        riskLocations: props.riskLocations,
        addLocations: props.addLocations,
        addLocationsSecurity: props.addLocationsSecurity,
        deleteLocation: props.deleteLocation,
        countries: state.step00.countries,
    }
}

export default connect(mapStateToProps, {
    getLatLong: findLatLong,
    fetchCountries,
})(Step02)


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/containers/Step02.tsx